import PieceDetails from "./PieceDetails";
export default PieceDetails;
